import type { MobileSnapshot } from '../domain/types'

/** Async boundary shared by local demo persistence and a future HttpRepository. */
export interface MobileRepository {
  load(): Promise<MobileSnapshot | null>
  save(snapshot: MobileSnapshot): Promise<void>
  clear(): Promise<void>
}

export interface StorageLike {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
  removeItem(key: string): void
}

export class MemoryStorage implements StorageLike {
  private readonly values = new Map<string, string>()

  getItem(key: string): string | null {
    return this.values.get(key) ?? null
  }

  setItem(key: string, value: string): void {
    this.values.set(key, value)
  }

  removeItem(key: string): void {
    this.values.delete(key)
  }
}

